<div class="spinner-wrapper">
  <mat-spinner />
</div>
